import '../scss/style.scss';
import moment from 'moment';
import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.jsx';
import {addLocaleData, IntlProvider } from 'react-intl';
import translations from './i18n/translation'
import LocaleSettings from "./common/LocaleSettings";
import initReactFastclick from 'react-fastclick';
import bootstrap from "bootstrap";

initReactFastclick();
addLocaleData(LocaleSettings.getDefaultIntlLocale());
moment.locale(LocaleSettings.getDefaultLocaleString(), LocaleSettings.getDefaultMomentLocale());

let messages = translations.messages || {};

ReactDOM.render(
    <IntlProvider locale={LocaleSettings.getDefaultLocaleString()} messages={messages}>
        <App/>
    </IntlProvider>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./web/src/index.js